import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { saveAreas, saveCategories, saveCountries, saveMarkets, saveSupports, saveUoms } from "redux/features/auth/authSlice";
import {
  useGetAreasQuery,
  useGetCategoriesQuery,
  useGetCountriesQuery,
  useGetMarketsQuery,
  useGetSupportsQuery,
  useGetUomsQuery,
} from "redux/features/user/userApi";

// Keeps the lookup lists in the persisted userAuth slice in sync with the API
// cache. Pages read these lists from the slice; since every write invalidates
// the matching tag, an admin edit refetches the list here and the slice (and
// every dropdown reading it) updates without each page refetching on its own.
const useSyncLookup = (result, save) => {
  const dispatch = useDispatch();
  const { data, error } = result;

  useEffect(() => {
    if (data?.status === "success") dispatch(save(data?.data));
  }, [data, dispatch, save]);

  // A 401 means the session ended; the base query already logs out and the
  // routes redirect, so don't add a toast per lookup on top of that.
  useEffect(() => {
    if (error && error.status !== 401) toast.error(error?.data?.message || "Something went wrong", { position: toast.POSITION.TOP_RIGHT });
  }, [error]);
};

const useLookups = () => {
  useSyncLookup(useGetCountriesQuery(), saveCountries);
  useSyncLookup(useGetMarketsQuery(), saveMarkets);
  useSyncLookup(useGetUomsQuery(), saveUoms);
  useSyncLookup(useGetCategoriesQuery(), saveCategories);
  useSyncLookup(useGetAreasQuery(), saveAreas);
  useSyncLookup(useGetSupportsQuery(), saveSupports);
};

export default useLookups;
